var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import FooterWidget from 'nucleus-widgets/lib/Footer/FooterWidget';
import { connect } from 'react-redux';
import { getPlannerPrivacyPolicyLink, getPrivacyPolicyLink as getPrivacyPolicyURL } from '../../utils/privacyPolicyUtils';
import { getCcpaConfirmationText, getCcpaExplanationText, getCcpaInviteeValidationText, getCcpaLinkText, getCcpaQualifyingQuestionFailureText, getCcpaQualifyingQuestionFlag, getCcpaQualifyingQuestionText, getCventPrivacyPolicyLinkText, getShowCcpaSectionFlag, isComplianceSnapshotMigrated, shouldShowCventPrivacyPolicy } from '../../redux/selectors/complianceSettings';
import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import { getIn } from 'icepick';
import { defaultMemoize } from 'reselect';
import CCPAOptOutDialog from './CCPAOptOutDialog';
import CCPADialogContent from './CCPADialogContent';
import FooterWidgetStyles from './FooterWidget.less';
import { CCPA_OPTOUT_OPTIONS, DIALOG_MODE } from '../../utils/ccpaUtils';
import renderRichText from 'nucleus-widgets/utils/renderRichText';
import { eventHasMultipleLanguages } from '../../utils/multiLanguageUtils';
var dialogStyle = defaultMemoize(function (globalTheme, style) {
    return __assign(__assign(__assign({}, globalTheme), style), { button: __assign(__assign({}, style.elements.primaryButton), { styleMapping: 'primaryButton' }), input: __assign(__assign({}, style.elements.input), { styleMapping: 'input' }), label: __assign(__assign({}, style.elements.label), { styleMapping: 'label' }), body1: __assign(__assign({}, style.elements.body1), { styleMapping: 'body1' }), header: globalTheme.dialog ? __assign({}, globalTheme.dialog.header) : { styleMapping: 'header3' }, dragHandle: globalTheme.dialog
            ? __assign(__assign({}, globalTheme.dialog.header), { spacing: { padding: 0 } }) : { styleMapping: 'header3' }, headerText: globalTheme.dialog ? globalTheme.dialog.headerText : { styleMapping: 'header2' }, messageContainer: globalTheme.dialog ? globalTheme.dialog.body : {} });
});
function getLocalizationsFromTheState(state) {
    var _a, _b;
    var currentLocale = (_a = state === null || state === void 0 ? void 0 : state.localizedUserText) === null || _a === void 0 ? void 0 : _a.currentLocale;
    return (_b = state === null || state === void 0 ? void 0 : state.localizedUserText) === null || _b === void 0 ? void 0 : _b.localizations[currentLocale];
}
function isMultiLanguageEventCheck(localizations, event) {
    return !!(eventHasMultipleLanguages(event) && localizations && Object.keys(localizations).length !== 0);
}
function getCcpaSettingsFromSnapshot(state) {
    var translate = state.text.translate;
    return {
        showComplianceText: translate(getShowCcpaSectionFlag(state)),
        complianceText: translate(getCcpaLinkText(state)),
        showQualifyingQuestion: translate(getCcpaQualifyingQuestionFlag(state)),
        qualifyingQuestionText: translate(getCcpaQualifyingQuestionText(state)),
        qualifyingErrorText: translate(getCcpaQualifyingQuestionFailureText(state)),
        successfulOptOutText: translate(getCcpaConfirmationText(state)),
        unregisteredForEventText: translate(getCcpaInviteeValidationText(state)),
        instructionalText: translate(getCcpaExplanationText(state))
    };
}
function getCcpaSettingsFromWebsite(ownProps, state, ccpaConfig) {
    var localizations = getLocalizationsFromTheState(state);
    var isMultiLanguageEvent = isMultiLanguageEventCheck(localizations, state.event);
    return {
        showComplianceText: ccpaConfig.visible,
        complianceText: isMultiLanguageEvent
            ? localizations['website.layoutItems.CventFooterSection.config.ccpa.linkText']
            : ccpaConfig.linkText,
        showQualifyingQuestion: ccpaConfig.qualifyingQuestion.visible,
        qualifyingQuestionText: isMultiLanguageEvent
            ? localizations['website.layoutItems.CventFooterSection.config.ccpa.qualifyingQuestion.text']
            : ccpaConfig.qualifyingQuestion.text,
        qualifyingErrorText: isMultiLanguageEvent
            ? localizations['website.layoutItems.CventFooterSection.config.ccpa.qualifyingQuestion.errorText']
            : ccpaConfig.qualifyingQuestion.errorText,
        successfulOptOutText: isMultiLanguageEvent
            ? localizations['website.layoutItems.CventFooterSection.config.ccpa.successfulOptOutText']
            : ccpaConfig.successfulOptOutText,
        unregisteredForEventText: isMultiLanguageEvent
            ? localizations['website.layoutItems.CventFooterSection.config.ccpa.unregisteredForEventText']
            : ccpaConfig.unregisteredForEventText,
        instructionalText: isMultiLanguageEvent && localizations['website.layoutItems.CventFooterSection.config.ccpa.content.blocks[0].text']
            ? renderRichText(localizations['website.layoutItems.CventFooterSection.config.ccpa.content.blocks[0].text'], ownProps.translate, ownProps.style.palette)
            : ccpaConfig.instructionalText &&
                renderRichText(ccpaConfig.instructionalText, ownProps.translate, ownProps.style.palette)
    };
}
export function getCcpaConfig(ownProps, state) {
    var _a;
    if ((state.experiments
        ? state.experiments.isMovePrivacyComplianceFromSiteEditorEnabled
        : (_a = state.experimentSettings) === null || _a === void 0 ? void 0 : _a.isMovePrivacyComplianceFromSiteEditorEnabled) &&
        isComplianceSnapshotMigrated(state)) {
        return getCcpaSettingsFromSnapshot(state);
    }
    var ccpaConfig = state.website.layoutItems.CventFooterSection.config.ccpa;
    if (ccpaConfig) {
        return getCcpaSettingsFromWebsite(ownProps, state, ccpaConfig);
    }
    return {};
}
var getPlannerPrivacyPolicy = function (links, config, isMultiLanguageEvent, localizations) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (config && config.plannerPrivacyPolicy && config.plannerPrivacyPolicy.visible) {
        links.push({
            url: isMultiLanguageEvent
                ? localizations['website.layoutItems.CventFooterSection.config.plannerPrivacyPolicy.url']
                : config.plannerPrivacyPolicy.url,
            text: isMultiLanguageEvent
                ? localizations['website.layoutItems.CventFooterSection.config.plannerPrivacyPolicy.text']
                : config.plannerPrivacyPolicy.text
        });
    }
    return links;
};
export function getPrivacyPolicyLinks(state, config) {
    var _a;
    var links = [];
    if ((state.experiments
        ? state.experiments.isMovePrivacyComplianceFromSiteEditorEnabled
        : (_a = state.experimentSettings) === null || _a === void 0 ? void 0 : _a.isMovePrivacyComplianceFromSiteEditorEnabled) &&
        isComplianceSnapshotMigrated(state)) {
        if (shouldShowCventPrivacyPolicy(state)) {
            links.push({
                url: getPrivacyPolicyURL(state.event.languageId || state.event.cultureCode),
                text: getCventPrivacyPolicyLinkText(state)
            });
        }
        return links.concat(getPlannerPrivacyPolicyLink(state));
    }
    var localizations = getLocalizationsFromTheState(state);
    var isMultiLanguageEvent = isMultiLanguageEventCheck(localizations, state.event);
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (config && config.cventPrivacyPolicy && config.cventPrivacyPolicy.visible) {
        links.push({
            url: getPrivacyPolicyURL(state.event.languageId || state.event.cultureCode),
            text: isMultiLanguageEvent
                ? localizations['website.layoutItems.CventFooterSection.config.cventPrivacyPolicy.text']
                : config.cventPrivacyPolicy.text
        });
    }
    return getPlannerPrivacyPolicy(links, config, isMultiLanguageEvent, localizations);
}
// returns appropriated widget to be displayed on editor or guest side
var EventFooterWidget = /** @class */ (function (_super) {
    __extends(EventFooterWidget, _super);
    function EventFooterWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.openCcpaDialog = function () {
            var _a = _this.props, isAdminReg = _a.isAdminReg, isAttendeeRegistered = _a.isAttendeeRegistered, CCPAConfig = _a.CCPAConfig, ccpaDialogMode = _a.ccpaDialogMode, switchCcpaDialogMode = _a.switchCcpaDialogMode;
            if (ccpaDialogMode === DIALOG_MODE.SUCCESS_OPT_OUT || ccpaDialogMode === DIALOG_MODE.FAILURE_OPT_OUT) {
                _this.setState({ ccpaGuestList: [] }, function () {
                    switchCcpaDialogMode(DIALOG_MODE.UNREGISTERED);
                });
            }
            _this.setState({ showCcpaDialog: true }, function () {
                if (!isAttendeeRegistered) {
                    switchCcpaDialogMode(DIALOG_MODE.UNREGISTERED);
                }
                else if (isAdminReg) {
                    switchCcpaDialogMode(DIALOG_MODE.ADMIN_REG);
                }
                else if (CCPAConfig.showQualifyingQuestion) {
                    switchCcpaDialogMode(DIALOG_MODE.SHOW_QUALIFYING_QUESTION);
                }
                else if (!CCPAConfig.showQualifyingQuestion) {
                    switchCcpaDialogMode(DIALOG_MODE.SHOW_USER_INFO);
                }
            });
        };
        _this.getCcpaComplianceRequest = function () {
            var _a = _this.props, primaryEventRegistrationInfo = _a.primaryEventRegistrationInfo, guestsEventRegistrationsInfo = _a.guestsEventRegistrationsInfo, isPlanner = _a.isPlanner;
            var ccpaGuestList = _this.state.ccpaGuestList;
            if (!primaryEventRegistrationInfo) {
                return [];
            }
            var ccpaComplianceRequests = [];
            ccpaComplianceRequests.push({
                firstName: primaryEventRegistrationInfo.firstName || '',
                lastName: primaryEventRegistrationInfo.lastName || '',
                email: primaryEventRegistrationInfo.emailAddress || '',
                attendeeEntityType: 'ATTENDEE',
                attendeeEntityId: primaryEventRegistrationInfo.attendeeEntityId,
                isCreatedByAttendee: !isPlanner
            });
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            var ccpaOptOutGuests = ccpaGuestList && ccpaGuestList.filter(function (guest) { return guest.checked; });
            if (ccpaOptOutGuests.length > 0) {
                ccpaOptOutGuests.forEach(function (optOutGuest) {
                    var guestRegistration = guestsEventRegistrationsInfo.filter(function (guest) { return guest.attendeeEntityId === optOutGuest.value; })[0];
                    ccpaComplianceRequests.push({
                        firstName: guestRegistration.firstName || '',
                        lastName: guestRegistration.lastName || '',
                        email: guestRegistration.emailAddress || '',
                        attendeeEntityType: 'GUEST',
                        attendeeEntityId: guestRegistration.attendeeEntityId,
                        isCreatedByAttendee: !isPlanner
                    });
                });
            }
            return ccpaComplianceRequests;
        };
        _this.updateGuests = function (guestList) {
            _this.setState({
                ccpaGuestList: guestList
            });
        };
        _this.closeCcpaDialog = function () {
            _this.setState({
                showCcpaDialog: false,
                ccpaGuestList: []
            }, function () { return _this.props.switchCcpaDialogMode(DIALOG_MODE.UNREGISTERED); });
        };
        _this.handleDialogConfirmationClick = function () {
            var ccpaOptOutValue = _this.state.ccpaOptOutValue;
            var _a = _this.props, makeCcpaComplianceRequest = _a.makeCcpaComplianceRequest, dialogMode = _a.ccpaDialogMode, switchCcpaDialogMode = _a.switchCcpaDialogMode;
            if (dialogMode === DIALOG_MODE.UNREGISTERED ||
                dialogMode === DIALOG_MODE.ADMIN_REG ||
                dialogMode === DIALOG_MODE.SUCCESS_OPT_OUT ||
                dialogMode === DIALOG_MODE.FAILURE_OPT_OUT ||
                dialogMode === DIALOG_MODE.SHOW_NO_CALAFORNIA_RESIDENT) {
                _this.setState({ showCcpaDialog: false });
            }
            else if (dialogMode === DIALOG_MODE.SHOW_QUALIFYING_QUESTION && ccpaOptOutValue === CCPA_OPTOUT_OPTIONS.YES) {
                switchCcpaDialogMode(DIALOG_MODE.SHOW_USER_INFO);
            }
            else if (dialogMode === DIALOG_MODE.SHOW_QUALIFYING_QUESTION && ccpaOptOutValue === CCPA_OPTOUT_OPTIONS.NO) {
                switchCcpaDialogMode(DIALOG_MODE.SHOW_NO_CALAFORNIA_RESIDENT);
            }
            else if (dialogMode === DIALOG_MODE.SHOW_USER_INFO) {
                makeCcpaComplianceRequest(_this.getCcpaComplianceRequest());
            }
        };
        _this.setOptOutRadioOptions = function (value) {
            _this.setState({ ccpaOptOutValue: value });
        };
        _this.state = {
            showCcpaDialog: false,
            ccpaOptOutValue: '',
            ccpaGuestList: []
        };
        return _this;
    }
    EventFooterWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { label: this.getElementInlineStyle('label'), input: this.getElementInlineStyle('input'), mainText: this.getElementInlineStyle('body1'), button: this.getElementInlineStyle('button'), header: this.getElementInlineStyle('header'), exit: this.getElementInlineStyle('headerText'), dragContainer: this.getElementInlineStyle('messageContainer'), headerFont: this.getElementInlineStyle('headerText') });
    };
    EventFooterWidget.prototype.getCCPAOptOutModalContent = function (props, classes) {
        var primaryEventRegistrationInfo = props.primaryEventRegistrationInfo, guestsEventRegistrationsInfo = props.guestsEventRegistrationsInfo, isAttendeeRegistered = props.isAttendeeRegistered, translate = props.translate, qualifyingQuestionText = props.qualifyingQuestionText, successfulOptOutText = props.successfulOptOutText, qualifyingErrorText = props.qualifyingErrorText, complianceText = props.complianceText, unregisteredForEventText = props.unregisteredForEventText, instructionalText = props.instructionalText, dialogMode = props.ccpaDialogMode;
        var style = this.getStyleObject();
        var modalContentConfig = {
            translate: translate,
            primaryEventRegistrationInfo: primaryEventRegistrationInfo,
            guestsEventRegistrationsInfo: guestsEventRegistrationsInfo,
            isAttendeeRegistered: isAttendeeRegistered,
            style: style,
            qualifyingQuestionText: qualifyingQuestionText,
            qualifyingErrorText: qualifyingErrorText,
            successfulOptOutText: successfulOptOutText,
            unregisteredForEventText: unregisteredForEventText,
            instructionalText: instructionalText,
            classes: classes,
            updateGuests: this.updateGuests,
            setOptOutRadioOptions: this.setOptOutRadioOptions,
            handleDialogConfirmationClick: this.handleDialogConfirmationClick,
            dialogMode: dialogMode
        };
        var modalConfig = {
            isOpen: true,
            isModal: true,
            header: translate(complianceText),
            isFixedHeader: false,
            isFullScreen: false,
            translate: translate,
            style: style,
            classes: classes,
            handleDialogClose: this.closeCcpaDialog,
            updateGuests: this.updateGuests,
            children: React.createElement(CCPADialogContent, __assign({}, modalContentConfig))
        };
        return React.createElement(CCPAOptOutDialog, __assign({}, modalConfig));
    };
    EventFooterWidget.prototype.render = function () {
        var props = this.props;
        var classes = FooterWidgetStyles;
        if (props.allowCustomFooter &&
            props.additionalPolicyLinks.length === 0 &&
            !props.CCPAConfig.showComplianceText &&
            props.isOnGuestSide) {
            return React.createElement("div", null);
        }
        var newProps = __assign(__assign(__assign({}, props), props.CCPAConfig), { onComplianceClick: this.openCcpaDialog });
        return (React.createElement(React.Fragment, null,
            this.state.showCcpaDialog && props.isOnGuestSide && this.getCCPAOptOutModalContent(newProps, classes),
            React.createElement(FooterWidget, __assign({}, newProps))));
    };
    EventFooterWidget.displayName = 'EventFooterWidget';
    EventFooterWidget.propTypes = {
        allowCustomFooter: PropTypes.bool,
        showPrivacyPolicy: PropTypes.bool,
        additionalPolicyLinks: PropTypes.array,
        isOnGuestSide: PropTypes.object,
        primaryEventRegistrationInfo: PropTypes.object,
        isAttendeeRegistered: PropTypes.bool,
        guestsEventRegistrationsInfo: PropTypes.array,
        isAdminReg: PropTypes.bool,
        style: PropTypes.object,
        translate: PropTypes.func,
        ccpaDialogMode: PropTypes.string,
        CCPAConfig: PropTypes.object,
        switchCcpaDialogMode: PropTypes.func,
        makeCcpaComplianceRequest: PropTypes.func
    };
    return EventFooterWidget;
}(BaseWidget));
export { EventFooterWidget };
/* Data wrapper for the footer widget */
export default connect(function (state, ownProps) { return ({
    allowCustomFooter: state.account.settings.allowCustomEventFooter,
    showPrivacyPolicy: false,
    additionalPolicyLinks: getPrivacyPolicyLinks(state, state.website.layoutItems.CventFooterSection.config),
    isOnGuestSide: getIn(state, ['userSession']),
    primaryEventRegistrationInfo: ownProps.primaryEventRegistrationInfo,
    guestsEventRegistrationsInfo: ownProps.guestsEventRegistrationsInfo,
    isAttendeeRegistered: ownProps.isAttendeeRegistered,
    style: dialogStyle(state.website.theme.global, ownProps.style),
    translate: ownProps.translate,
    isAdminReg: ownProps.isAdminReg,
    CCPAConfig: getCcpaConfig(ownProps, state),
    makeCcpaComplianceRequest: ownProps.makeCcpaComplianceRequest,
    switchCcpaDialogMode: ownProps.switchCcpaDialogMode,
    ccpaDialogMode: ownProps.ccpaDialogMode
}); })(EventFooterWidget);
